import DetailView from './DetailView';

function ProductCard(props) {
  return (
    <div class="rounded-lg w-full border bg-white shadow-xl ">
      <div class={` h-${ props.h ? props.h : "full" } mb-2  w-full relative`}>
        <div className="w-full absolute p-4 z-10 top-0">
          <div className="float-left">
            <span className="bg-gray-800 rounded-full p-2 text-sm text-white">
              New
            </span>
          </div>
          <div className="float-right">
            <span className="bg-[#fb9815] hover:bg-white hover:text-[#fb9815] rounded-full p-2 text-sm text-white">
              -20%
            </span>
          </div>
        </div>
        <div className="absolute w-full h-full bg-black opacity-0 hover:opacity-100 transition duration-100 ease-in bg-opacity-75">
          <DetailView img={props.img} name={props.name} price={props.price} />
        </div>
        <img
          src={props.img}
          alt=""
          class="h-full w-full  object-center object-contain"
        />
      </div>
      <div className="hidden lg:block lg:flex gap-4 w-1/2 mx-auto items-justify objects-center">
      <img
          src={props.img}
          alt=""
          class="w-12 h-12 rounded-lg object-center object-cover"
        />
        <img
          src={props.img}
          alt=""
          class="w-12 h-12 rounded-lg object-center object-cover"
        />
        <img
          src={props.img}
          alt=""
          class="w-12 h-12 rounded-lg object-center object-cover"
        />
       </div> 
      <div class="p-2  text-center">
        <h2 class="text-lg font-bold">{props.name}</h2>

        <div class="text-[#fb9815] flex w-full 
        justify-center ">
          <svg
            class="w-4 h-4 "
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
          </svg>
          <svg
            class="w-4 h-4 "
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
          </svg>
          <svg
            class="w-4 h-4 "
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
          </svg>
          <svg
            class="w-4 h-4 "
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
          </svg>
          <svg
            class="w-4 h-4 "
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
          </svg>
          <i class="text-xs lg:text-sm text-gray-600"> ( 200 )</i>
        </div>
        <h3 class="text-lg font-bold text-black">
          {props.price} <strike class="text-gray-600">70.00</strike>
        </h3>
      </div>
      <div class="text-center p-6 lg:flex">
        {/* <button class="hidden rounded-lg w-full border border-gray-600 text-gray-600 hover:bg-gray-600 hover:text-gray-900 p-2">
          Add To Cart
        </button> */}
        {/* <button class=" rounded-lg w-full mt-2 lg:mt-0  bg-gray-600 text-gray-100 p-2">
          {props.cta}
        </button> */}
        <div className="w-full mx-auto">
        <button
          type="button"
        
          className={` text-lg text-center w-full mx-auto p-1 font-medium text-white bg-[#fb9815]
            
            rounded-md `}
        >
          Add To Cart
        </button>
      </div>
        
      </div>
    </div>
  );
}

export default ProductCard;
